<script lang="ts" setup>
import { ref, defineProps, defineModel, onMounted } from "vue";
import { PropType } from "@vue/runtime-core";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  items: Array as PropType<string[]>,
});

const selectValue = defineModel<string>({
  default: "",
});

const activeState = ref<boolean>(false);
const activeItem = ref<string>("");

const chooseItem = (item: string) => {
  activeItem.value = item;
  activeState.value = false;
  selectValue.value = item;
};

onMounted(() => {
  activeItem.value = props.placeholder || t("base.select.placeholder");
});
</script>

<template>
  <div class="base-select" :class="{ active: activeState }">
    <div class="base-select--block" @click="activeState = !activeState">
      <div class="base-select--block-placeholder">
        <p class="color-text-primary caption-medium">{{ activeItem }}</p>
      </div>
      <div class="base-select--block-arrow color-grey-light">
        <BaseIcon
          name="service-arrow"
          :position="activeState ? 'top' : 'bottom'"
        />
      </div>
    </div>
    <div class="base-select--drop" :class="{ active: activeState }">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="base-select--drop-item"
        @click="chooseItem(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/main";

.base-select {
  position: relative;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  &--block {
    background: var(--color-bg-primary);
    border: none;
    width: 100%;
    padding: 24px 17px 20px 20px;
    font-family: inherit;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-arrow {
    }
  }

  &--drop {
    display: flex;
    position: absolute;
    background-color: var(--color-white);
    border-radius: 12px;
    left: 0;
    top: 0;
    width: 100%;
    padding: 24px 16px;
    margin-top: 8px;
    box-shadow: 6px 6px 10px 0 #00000008;
    flex-flow: column;
    gap: 24px;
    transition: all 0.2s;
    opacity: 0;
    pointer-events: none;

    &.active {
      //display: flex;
      top: 100%;
      opacity: 1;
      pointer-events: auto;
    }

    &-item {
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: var(--color-secondary);
      }
    }
  }
}
</style>
